import React from 'react'
import styled from "styled-components";
import FramePuzzlePrizes from "../../../../assets/images/Event-2026/FramePuzzlePrizes.png";
import FrameMission from "../../../../assets/images/Event-2026/FrameMission.png";
import Icon1 from "../../../../assets/images/Event-2026/icon1.svg";
import Icon from "../../../../assets/images/Event-2026/icon.svg";
import IconCheck from "../../../../assets/images/Event-2026/iconV.svg";
import BID0 from "../../../../assets/images/Event-2026/BID1.png";
import BID from "../../../../assets/images/Event-2026/buy-bid.png";
import BID2 from "../../../../assets/images/Event-2026/buy-bid-2.png";
import BID10 from "../../../../assets/images/Event-2026/buy-bid-10.png";
import BID5 from "../../../../assets/images/Event-2026/buy-bid-5.png";
import Package from "../../../../assets/images/Event-2026/Subscribe.png";
import FrameMission2 from "../../../../assets/images/Event-2026/FrameMission2.png";
import FrameMission3 from "../../../../assets/images/Event-2026/FrameMission3.png";
import FrameMission1 from "../../../../assets/images/Event-2026/FramePuzzlePrizes22.png";
import FrameCollection2 from "../../../../assets/images/Event-2026/FramePuzzlePrizes33.png";
import FrameCollection3 from "../../../../assets/images/Event-2026/FramePuzzlePrizes44.png";
import CoinGold from "../../../../assets/images/Event-2026/crown1.png";

import { Button } from 'antd';
import { useNavigate } from '@hooks/useNavigate';
import PATH from '@config/PATH';
import { ID_TAB_MINI_GAME } from 'helper/const';
import { getMiniGameMissionsQuery } from 'dataLayer/miniGame';
import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';

const specialPackages = [
	"CHANCE10",
	"SUBASTA_WEEKLY",
	"SUBASTA_MONTHLY",
];

const background1 = [
	"CHANCE",
	"CHANCE2",
	"CHANCE5",
	"CHANCE10",
];

const background2 = [
	"SUBASTA_DAILY",
	"SUBASTA_WEEKLY",
	"SUBASTA_MONTHLY",
];

const packageIcons = {
	CHANCE: BID0,
	CHANCE2: BID0,
	CHANCE5: BID0,
	CHANCE10: BID0,
};

const Items = ({ item, background, type }) => {
	const navigate = useNavigate();
	const { t } = useTranslation()

	const coin = specialPackages.includes(item?.package); // check show số coin 
	let checkIcon = Icon1; // check show icon

	if (background === 1) {
		checkIcon = packageIcons[item?.package] || BID0;
	}

	if (background === 2) {
		checkIcon = Package;
	}

	return (
		<div className={`item item-${background || 0}`}>
			<div className='info-item'>
				<img src={checkIcon} alt="image" className='item-image' />
				<div className={`sub-item ${background ? `sub-item-${background}` : ''}`}>
					<span className='sub-item_title'>{item.name}</span>
					<div className={`sub-item_image ${type === 1 ? `text-coin` : 'text-coin-super'}`}>

						{
							coin ?
								<>
									<img src={Icon} alt="image" />
									<span>+{item.normal_coin} {t('coin')}</span>
									{" "}
									<img src={CoinGold} alt="image" />
									<span>+{item.supper_coin} {t('coin')}</span>
								</>
								:
								<>
									<img src={Icon} alt="image" />
									<span>+{item.normal_coin} {t('coin')}</span>
								</>
						}

					</div>
				</div>
			</div>
			<Button
				disabled={item?.completed === 0 ? false : true}
				onClick={() => navigate(`${item.link}`)}
				className={`btn-item ${item?.completed === 0 ? 'execute' : 'completed'}`}
			>
				{item?.completed === 0 ? t('execute') :
					<>
						<img src={IconCheck} alt="image" className='icon-completed' />
						{t('completed')}
					</>}
			</Button>
		</div>
	)
}

const List = ({ data, background, type }) => {
	return (
		<div className='list'>
			<div className='list-product'>
				{
					data
						?.filter(item => item.type === type)
						?.map((item, index) => (
							<Items
								key={Number(item.id) + index}
								item={item}
								background={background}
								type={type}
							/>
						))
				}
			</div>
		</div>
	)
}

const DailyMission = ({ data }) => {
	const { t } = useTranslation()
	return (
		<div className='daily-mission'>
			<h3>{t('daily_mission')}</h3>
			<List data={data} type={1} />
		</div>
	)
}

const MoreMission = ({ data }) => {
	const { t } = useTranslation()
	return (
		<div className='more-mission'>
			<h3>{t('more_mission')}</h3>
			<List
				data={data?.filter(item =>
					background1?.includes(item.package)
				)}
				background={1}
				type={2}
			/>
			<List
				data={data?.filter(item =>
					background2?.includes(item.package)
				)}
				background={2}
				type={2}
			/>
		</div>
	)
}

export default function MissionToEarnCoins() {
	const navigate = useNavigate();
	const { t } = useTranslation()
	const { data } = useQuery(getMiniGameMissionsQuery());

	const handleChangeCollectPiece = () => {
		navigate(`${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.collectPiece}`);
	}

	return (
		<Container>
			<div className='frame'>
				<div className="frame-top">
					<h4 className='title'>{t('mission_to_earn_coins')}</h4>
				</div>
				<span className='btn-sell' onClick={handleChangeCollectPiece}>
					<span>{t('see_all')}</span>
				</span>
				<div className="frame-middle">
					<DailyMission data={data} />
					<MoreMission data={data} />
				</div>
				<div className="frame-bottom" />
			</div>
		</Container>
	)
}

const Container = styled.div`
		/* TOP */
		.frame-top {
			background-image: url(${FrameMission1});
			background-repeat: no-repeat;
			background-size: 100% 100%;
			height: 115px;
			position: relative;
				@media (max-width: 768px) {
					height: 80px;
				}
		}

		/* MIDDLE */
  .frame-middle {
    background-image: url(${FrameCollection2});
    background-repeat: repeat-y;
    background-size: 100% 100%;
    height: 100%;
    min-height: 400px;
  }

	  /* BOTTOM */
  .frame-bottom {
    background-image: url(${FrameCollection3});
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 40px;
  }

	.frame {
		position: relative;
		max-width: 1200px;
		margin: auto;

		@media (max-width: 768px) {
			width: 100%;
			padding-bottom: 20px;
		}
	}

	.btn-sell{
		border: none;
		outline: none;
		width: 124px;
    height: 40px;
    position: absolute;
    top: 2px;
    right: 4%;
		text-align: right;
		z-index: 2;

		@media (max-width: 768px) {
				background-size: 100% 100%;
				width: 90px;
				height: 40px;
				top: 12px;
				right: 25px;
		}

		@media (max-width: 480px) {
			background-size: 100% 100%;
				width: 70px;
				height: 40px;
				top: 12px;
				right: 9px;
		}

	
		 @media (min-width: 768px) and (max-width: 1024px) {
			 right: 25px;
				top: 12px;
			}

			@media (min-width: 834px) and (max-width: 1194px) {
				right: 30px;
				top: 12px;
			}

			@media (min-width: 1024px) and (max-width: 1366px) {
				right: 25px;
				top: 12px;
			}


		span{
			display: inline-block;
			padding-top: 25px;
			padding-right: 20px;
			text-align: right;
			font-weight: 700;
			font-size: 20px;
			text-decoration: underline;
			color: #fff;
			cursor: pointer;

			@media (max-width: 480px) {
        font-size: 12px;
        padding-right: 10px;
      }

      @media (max-width: 768px) {
        padding-top: 10px;
				font-size: 12px;
        padding-right: 13px;
      }

			@media (min-width: 768px) and (max-width: 1024px) {
			padding-top: 20px;
        padding-right: 10px;
			font-size: 16px;

			}

			@media (min-width: 834px) and (max-width: 1194px) {
				padding-top: 18px;
			font-size: 16px;
        padding-right: 10px;
			}

			@media (min-width: 1024px) and (max-width: 1366px) {
				padding-top: 17px;
			font-size: 18px;
        padding-right: 30px;
			}
		}
	}

	.title{
		color: rgba(253, 221, 16, 1);
		font-size: 20px;
		font-weight: 800;
		text-transform: uppercase;
		position: absolute;
		top: 43px;
    left: 4.5%;

		@media (max-width: 768px) {
			top: 26%;
			left: 5%;
			font-size: 14px;
			line-height: 18px;
			max-width: 250px;
		}
		@media (min-width: 768px) and (max-width: 1024px) {
				font-size: 14px;
			}

			@media (min-width: 834px) and (max-width: 1194px) {
						font-size: 16px;
			}

			@media (min-width: 1024px) and (max-width: 1366px) {
						font-size: 18px;

			}
	}

	.list {
		width: 100%;
		padding: 0 42px;
		box-sizing: border-box;
		position: relative;
		box-sizing: border-box;
		padding: 5px 42px;
		/* margin-bottom: 20px; */
		@media (max-width: 768px) {
			padding: 0 20px;
			margin-bottom: 0px;
		}
	}

	.list-product {
		display: flex;
		gap: 7px;
		overflow-x: auto;
		scroll-behavior: smooth;
		width: 100%;
		box-sizing: border-box;
		-webkit-overflow-scrolling: touch;

		@media (max-width: 768px) {
				&::-webkit-scrollbar {
				display: none;
			}
		}
	}

	.item {
		background-image: url(${FrameMission});
		background-position: center;
		background-repeat: no-repeat;
		background-size: 100% 100%;
		width: 310px;
		height: fit-content;
		min-width: 110px;
		flex-shrink: 0;
		padding: 10px;
		margin-bottom: 10px;

		&.item-1 {
			background-image: url(${FrameMission2});
			min-height: 122px;
			.info-item{
				min-height: 58px;
			}
		}

		&.item-2 {
			background-image: url(${FrameMission3});
			min-height: 160px;
			.info-item{
				min-height: 90px;
			}
		}

		@media (max-width: 768px) {
			width: 260px;
			height: fit-content;
		}

		.info-item{
			display: flex;
			gap: 10px;
			height: 100%;
			/* max-height: 65px; */

			.item-image{
				width: 40px;
				height: 40px;
			}
			.sub-item{
				.sub-item_title{
					color: #fff;
					font-weight: 700;
					font-size: 15px;
					line-height: 15px;
					width: 100%;
					white-space: normal;
					word-break: break-word;
					overflow-wrap: break-word;
				}
				.sub-item_image{
					span{
						font-weight: 600;
					}
					img{
						width: 20px;
						height: 20px;
						padding-right: 3px;
					}
				}
				
				.text-coin{
						color: #fff;
						font-weight: 600;
				}
				.text-coin-super{
						color: rgba(22, 36, 129, 1);
						line-height: 15px;
				}
				&.sub-item-1,
				&.sub-item-2 {
					.sub-item_title{
						font-weight: 700;
						font-size: 15px;
						color: rgba(22, 36, 129, 1);
						line-height: 15px;
					}
					.sub-item_image span {
						color: rgba(22, 36, 129, 1);
						font-weight: 600;
						line-height: 15px;
					}
				}
			}
		}

		.btn-item{
			border-radius: 7px;
			margin-top: 10px;
			width: 100%;
			border: none;
			outline: none;
			background: linear-gradient(
					180deg,
					rgba(217, 96, 20, 1) 0%,
					rgba(254, 145, 4, 1) 100%
				);
				span{
					font-size: 16px;
					font-weight: 500;
					color: #fff;
				}
			.icon-completed{
				width: 20px;
				height: 20px;
				margin-right: 5px;
				margin-bottom: 5px;
			}
		}
		.completed{
			background: linear-gradient(
					180deg,
					rgba(30, 163, 23, 1) 0%,
					rgba(25, 184, 16, 1) 100%
				);
		}
		.execute{
			background: linear-gradient(
					180deg,
					rgba(217, 96, 20, 1) 0%,
					rgba(254, 145, 4, 1) 100%
				);	
		}
	}
	.daily-mission{
		@media (max-width: 768px) {
				/* padding-top: 52px; */
		}
		h3{
			color: rgba(166, 186, 255, 1);
			font-size: 18px;
			font-weight: 800;
			text-transform: uppercase;
			padding: 0 40px;
		}
	}
	.more-mission{
		h3{
			color: rgba(166, 186, 255, 1);
			font-size: 18px;
			font-weight: 800;
			text-transform: uppercase;
			padding: 0 40px;
		
		}
	}
	.daily-mission,
	.more-mission {
		position: relative;
		top: unset;
		bottom: unset;
		width: 100%;
		height: auto;
		h3{
			@media (max-width: 480px) {
				font-size: 14px;
			}
		}
	}
`;
